import {
  Container,
  Grid,
  Hidden,
  List,
  ListItem,
  ListItemText,
  Typography,
} from '@mui/material'
import { Box } from '@mui/system'
import Moon from './moon.svg'
import { Xwrapper } from 'react-xarrows'
import Xarrow from 'react-xarrows'

export default function RMMobile() {
  return (
    <>
      <Xwrapper>
        <Grid
          container
          direction="row"
          alignItems="center"
          maxWidth="lg"
          margin="auto"
        >
          {/* <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m1" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  October
                </span>
                <br />
                <br />
                <span>October 15th : Yahoo Finance Article</span>
                <br />
                <br />
                <span>October 15th : Coinmarketcap Article</span>
                <br />
                <br />
                <span>
                  October 18th : Github Repo on Solana website for Solana
                  recognition
                </span>
                <br />
                <br />
                <span>October 20th : Pre – Sale</span>
                <br />
                <br />
                <span>
                  <b>October 20th : Swap Solar for Solana on Solar Dex</b>
                </span>
                <br />
                <br />
                <span>October 21st to 31st : Marketing</span>
                <br />
                <br />
              </Box>
            </Grid>
          </Grid> */}
          <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m2" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  November
                </span>
                <br />
                <br />
                <span>Coinmarketcap [DONE]</span>
                <br />
                <br />
                <span>Yahoo Finance [DONE]</span>
                <br />
                <br />
                <span>Bloomberg [DONE]</span>
                <br />
                <br />
                <span>PR Releases [DONE]</span>
                <br />
                <br />
                <span>Pre Sale [Pending]</span>
                <br />
                <br />
                <span>Solar Token Launch [Pending]</span>
                <br />
                <br />
              </Box>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m3" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  December
                </span>
                <br />
                <br />
                <span>Solar Labs: Weekly Development Updates</span>
                <br />
                <br />
                <span>Youtube Channel</span>
                <br />
                <br />
                <span>Lobby for Defi</span>
                <br />
                <br />
                <span>Cointelegraph Article</span>
                <br />
                <br />
                <span>Develop Staking Contract</span>
                <br />
                <br />
                <span>Staking Contract Audit</span>
                <br />
                <br />
                <span>Deploy Staking Contract for Solar on mainnet</span>
                <br />
              </Box>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m4" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  January
                </span>
                <br />
                <br />
                <span>Develop Trade Smart Contract</span>
                <br />
                <br />
                <span>Develop Liquidity Pools Contract</span>
                <br />
                <br />
                <span>Incorporate Liquidity Lock AMM in Pool contract</span>
                <br />
                <br />
                <span>BSC Bridge</span>
                <br />
                <br />
                <span>Audit [all smart contracts]</span>
                <br />
                <br />
                <span>Deploy to main net [all smart contracts]</span>
                <br />
                <br />
                <span>Beta Testers for Dex</span>
                <br />
                <br />
                <span>Full Roll out of Dex</span>
                <br />
                <br />
              </Box>
            </Grid>
          </Grid>
          <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m5" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  February
                </span>
                <br />
                <br />
                <span>Centralized Exchange Listing</span>
                <br />
                <br />
                <span>IOS and Android App</span>
                <br />
                <br />
                <span>On / Off ramp for USD Beta Testing</span>
                <br />
                <br />
              </Box>
            </Grid>
          </Grid>

          <Grid
            item
            container
            justifyContent="space-between"
            xs={12}
            sx={{ color: 'white', textAlign: 'center' }}
            mb={5}
          >
            <Grid item xs={2}>
              <Box id="m6" sx={{ padding: '10px 0px 20px 0px' }}>
                <img src={Moon} zIndex={1} />
              </Box>
            </Grid>
            <Grid item xs={10} sx={{ textAlign: 'left' }}>
              <Box mt={2}>
                <span
                  style={{
                    color: 'aqua',
                    fontWeight: 'bolder',
                    fontSize: '20px',
                  }}
                >
                  March - December:
                </span>
                <br />
                <br />
                <span>Upgrades</span>
                <br />
                <br />
                <span>Onboard New Projects to Dex</span>
                <br />
                <br />
                <span>Extensive Marketing</span>
                <br />
                <br />
              </Box>
            </Grid>
          </Grid>
        </Grid>
        {/* <Xarrow
          color="#BAB3C2"
          showHead={false}
          showTail={false}
          strokeWidth={9}
          start={'m1'}
          end={'m2'}
          zIndex={0}
        /> */}
        <Xarrow
          color="#BAB3C2"
          showHead={false}
          showTail={false}
          strokeWidth={9}
          start={'m2'}
          end={'m3'}
          zIndex={0}
        />
        <Xarrow
          color="#BAB3C2"
          showHead={false}
          showTail={false}
          strokeWidth={9}
          start={'m3'}
          end={'m4'}
          zIndex={0}
        />
        <Xarrow
          color="#BAB3C2"
          showHead={false}
          showTail={false}
          strokeWidth={9}
          start={'m4'}
          end={'m5'}
          zIndex={0}
        />
        <Xarrow
          color="#BAB3C2"
          showHead={false}
          showTail={false}
          strokeWidth={9}
          start={'m5'}
          end={'m6'}
          zIndex={0}
        />
      </Xwrapper>
    </>
  )
}
